import React from "react";
import "./Generative.css";

const Generative = () => {
  return (
    <div className="generative">
      <div className="generative__aiCard">
        <img
          src="images/ai.png"
          alt="ai"
          style={{ width: "22px", height: "22px" }}
          className="generative__img"
        />
        <p className="generative__ai-title">Generative AI is experimental</p>
      </div>
      <p className="generative__ai-text">
        Google's main source of revenue is Google advertising, which includes
        revenues generated on Google search properties, YouTube ads, and Google
        Network properties. [1]
      </p>
    </div>
  );
};

export default Generative;
